import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { fetchFormItems } from '../../../utils'

/*
const sampleDetail = {
  index: 23,
  count: 99,

  comment: '',
  source: '114.234.248.164 中国-北京-北京',

  rows: [{
    icon: 'name',
    name: '姓名',
    value: '张强'
  }, {
    icon: 'mail',
    name: '邮箱',
    value: 'abcabc@defdefff.com'
  }, {
    icon: 'phone',
    name: '手机',
    value: '12311112222'
  }, {
    icon: 'org',
    name: '机构名称',
    value: '海淀社工'
  }, {
    icon: 'comment',
    name: '有什么想和我叨叨的',
    content: '为一个临终关爱的患晚期肺癌的老人，拍一个宣传片，没有宣传渠道和资源，只有几个屌丝社工和一些怀揣梦想的大学生志愿者，你们能施以援手吗？'
  }, {
    icon: 'source',
    name: '来源',
    value: '114.234.248.164 中国-北京-北京'
  }, {
    name: 'name',
    value: 'value'
  }, {
    name: 'name',
    content: '为一个临终关爱的患晚期肺癌的老人，拍一个宣传片，没有宣传渠道和资源，只有几个屌丝社工和一些怀揣梦想的大学生志愿者，你们能施以援手吗？'
  }]
}
*/

const state = {
  index: 0,
  count: 0,

  rows: [],
  privateForm: ''
}

const actions = {
  [aTypes.FORM_GET_FEEDBACK_DETAIL] ({ commit }, { contactId, formId, formfillId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_FEEDBACK_DETAIL, loading: true })
    api.form.getFeedbackDetail({
      success (res) {
        const body = res.body
        if (body.not_have_private_form_auth === true) {
          commit(mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM_DETAIL, true)
        } else {
          const detail = {
            index: body.position ? body.position.current : '?',
            count: body.position ? body.position.total : '?',
            rows: fetchFormItems(body.form.form_items, body.data)
          }
          commit(mTypes.FORM_SET_FEEDBACK_DETAIL, detail)
          commit(mTypes.SET_NAV_TITLE, body.form.title)
          commit(mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM_DETAIL, false)
          commit(mTypes.SET_PAGINATION, {
            prevTo: body.prev_record_id ? {
              path: '/main/form/feedback-detail',
              query: {
                contactId,
                formId,
                formfillId: body.prev_record_id
              }
            } : null,
            nextTo: body.next_record_id ? {
              path: '/main/form/feedback-detail',
              query: {
                contactId,
                formId,
                formfillId: body.next_record_id
              }
            } : null
          })
          commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_FEEDBACK_DETAIL, loading: false })
        }
      },
      commit
    }, { contactId, formId, formfillId })
  },
  [aTypes.FORM_GET_RECORD_NOTES] ({ commit }, { form_id, form_fill_id, current_num }) {
    commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_RECORD_NOTES, loading: true })
    api.form.getRecordNoteMore({
      success (res) {
        const body = res.body
        const detail = {
          index: body.position ? body.position.current : '?',
          count: body.position ? body.position.total : '?',
          rows: fetchFormItems(body.form.form_items, body.data)
        }
        commit(mTypes.FORM_SET_FEEDBACK_DETAIL, detail)

        commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_RECORD_NOTES, loading: false })
      },
      commit
    }, { form_id, form_fill_id, current_num })
  }
}

const mutations = {
  [mTypes.FORM_SET_FEEDBACK_DETAIL] (state, detail) {
    state.index = detail.index
    state.count = detail.count
    state.rows = detail.rows
  },
  [mTypes.FORM_SET_FEEDBACK_PRIVATE_FORM_DETAIL] (state, status) {
    state.privateForm = status
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form/feedbackDetail.js